export const MENU_MODULE_NAMES = {
	budgetBuilder: 'budget',
	fundManagement: 'fund',
	payroll: 'payroll',
	linqSchoolBookkeeping: 'lsb',
	systemSettings: 'system',
	fixedAssets: 'fa',
	'dynamic-reporting': 'dr',
};
